import React from 'react'
import { useContainerWidth } from '@fs/zion-ui'

export default function ContentWrapper({ children }) {
  const atWidth = useContainerWidth()
  const isWide = atWidth({ default: false, xl: true })
  const style = isWide
    ? { height: 'calc(100vh - 210px)', overflowY: 'auto', overflowX: 'hidden' }
    : { maxHeight: 'calc(100vh - 210px)', overflowY: 'auto', overflowX: 'hidden' }

  return <div style={style}>{children}</div>
}
